// Centralized color tokens for reuse across components and theme

export const COLORS = {
  primary: "#84B6CC",
  secondary: "#84B6CC", // Brand Secondary provided as same as primary
  brandBackground: "#475161",
  darkGrey: "#888",
  mediumGrey: "#E9E9E9",
  lightGrey: "#F2F5F5",
  white: "#FFF",
  black: "#000",
} as const;

export type AppColorKey = keyof typeof COLORS;
export type AppColors = typeof COLORS;
